import { reactive } from 'vue';
import { PermissionService } from '@/services/permissionService';

const permissionService = new PermissionService();

const permissionsStore = reactive({
    permissions: null,
    permissionLoaded: false,
    loading: false,
    error: null,
});

export const usePermissions = () => {
    const loadPermissions = async (forceRefresh = false) => {
        // If already loaded and not forcing refresh, return existing data
        if (permissionsStore.permissionLoaded && !forceRefresh) {
            return permissionsStore.permissions;
        }
        
        // If already loading, wait for it to complete
        if (permissionsStore.loading) {
            // Wait for loading to complete
            while (permissionsStore.loading) {
                await new Promise(resolve => setTimeout(resolve, 50));
            }
            return permissionsStore.permissions;
        }
        
        try {
            permissionsStore.loading = true;
            permissionsStore.error = null;
            permissionsStore.permissions = await permissionService.getUserPermission();
            permissionsStore.permissionLoaded = true;
            return permissionsStore.permissions;
        } catch (error) {
            permissionsStore.error = error;
            permissionsStore.permissionLoaded = false;
            throw error;
        } finally {
            permissionsStore.loading = false;
        }
    };

    const temPermissao = (funcionalidadeId) => {
        if (!permissionsStore.permissions || !permissionsStore.permissions.funcionalidadesId) {
            return false;
        }
        
        return permissionsStore.permissions.funcionalidadesId.includes(funcionalidadeId);
    };

    return {
        permissions: permissionsStore,
        loadPermissions,
        temPermissao,
    };
};

// Export the store directly for direct access
export { permissionsStore };
